import { render, staticRenderFns } from "./phoneLoginComponent.vue?vue&type=template&id=a65e38cc"
import script from "./phoneLoginComponent.vue?vue&type=script&lang=js"
export * from "./phoneLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports